import { render, staticRenderFns } from "./Statuses_masters.vue?vue&type=template&id=5ce99ef4&"
import script from "./Statuses_masters.vue?vue&type=script&lang=js&"
export * from "./Statuses_masters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports